import {useSelector} from 'react-redux';
import {EMPTY_LIST} from '../../constants/empty.constants';

/**
 * Ids of the Open Banking accounts this employee may see, with a reference-stable empty fallback.
 * @returns {Array<string>} Account access ids, or a shared empty array.
 */
export const useOpenBankingAccountAccessIds = () => useSelector(state => state.openBanking?.accountAccessIds ?? EMPTY_LIST);
